import { b as p, g as ee, c as re, f as te, e as le, a as J, h as L } from "./chunk-I2QGXAA3.js";
import { twMerge as ne, extendTailwindMerge as oe } from "../../../../tailwind-merge@2.5.4/bundled_deps/tailwind-merge/dist/bundle-mjs.js";
var ae = { twMerge: !0, twMergeConfig: {}, responsiveVariants: !1 }, U = (s) => s || void 0, M = (...s) => U(le(s).filter(Boolean).join(" ")), S = null, g = {}, P = !1, w = (...s) => (m) => m.twMerge ? ((!S || P) && (P = !1, S = p(g) ? ne : oe({ ...g, extend: { theme: g.theme, classGroups: g.classGroups, conflictingClassGroupModifiers: g.conflictingClassGroupModifiers, conflictingClassGroups: g.conflictingClassGroups, ...g.extend } })), U(S(M(s)))) : M(s), Q = (s, m) => {
  for (let l in m) s.hasOwnProperty(l) ? s[l] = M(s[l], m[l]) : s[l] = m[l];
  return s;
}, ue = (s, m) => {
  let { extend: l = null, slots: C = {}, variants: R = {}, compoundVariants: B = [], compoundSlots: h = [], defaultVariants: K = {} } = s, d = { ...ae, ...m }, G = l != null && l.base ? M(l.base, s?.base) : s?.base, y = l != null && l.variants && !p(l.variants) ? ee(R, l.variants) : R, O = l != null && l.defaultVariants && !p(l.defaultVariants) ? { ...l.defaultVariants, ...K } : K;
  !p(d.twMergeConfig) && !re(d.twMergeConfig, g) && (P = !0, g = d.twMergeConfig);
  let k = p(l?.slots), N = p(C) ? {} : { base: M(s?.base, k && l?.base), ...C }, V = k ? N : Q({ ...l?.slots }, p(N) ? { base: s?.base } : N), j = p(l?.compoundVariants) ? B : te(l?.compoundVariants, B), b = (f) => {
    if (p(y) && p(C) && k) return w(G, f?.class, f?.className)(d);
    if (j && !Array.isArray(j)) throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof j}`);
    if (h && !Array.isArray(h)) throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof h}`);
    let _ = (e, t, r = [], o) => {
      let n = r;
      if (typeof t == "string") n = n.concat(L(t).split(" ").map((a) => `${e}:${a}`));
      else if (Array.isArray(t)) n = n.concat(t.reduce((a, i) => a.concat(`${e}:${i}`), []));
      else if (typeof t == "object" && typeof o == "string") {
        for (let a in t) if (t.hasOwnProperty(a) && a === o) {
          let i = t[a];
          if (i && typeof i == "string") {
            let u = L(i);
            n[o] ? n[o] = n[o].concat(u.split(" ").map((c) => `${e}:${c}`)) : n[o] = u.split(" ").map((c) => `${e}:${c}`);
          } else Array.isArray(i) && i.length > 0 && (n[o] = i.reduce((u, c) => u.concat(`${e}:${c}`), []));
        }
      }
      return n;
    }, q = (e, t = y, r = null, o = null) => {
      var n;
      let a = t[e];
      if (!a || p(a)) return null;
      let i = (n = o?.[e]) != null ? n : f?.[e];
      if (i === null) return null;
      let u = J(i), c = Array.isArray(d.responsiveVariants) && d.responsiveVariants.length > 0 || d.responsiveVariants === !0, A = O?.[e], v = [];
      if (typeof u == "object" && c) for (let [E, I] of Object.entries(u)) {
        let $ = a[I];
        if (E === "initial") {
          A = I;
          continue;
        }
        Array.isArray(d.responsiveVariants) && !d.responsiveVariants.includes(E) || (v = _(E, $, v, r));
      }
      let x = u != null && typeof u != "object" ? u : J(A), T = a[x || "false"];
      return typeof v == "object" && typeof r == "string" && v[r] ? Q(v, T) : v.length > 0 ? (v.push(T), r === "base" ? v.join(" ") : v) : T;
    }, F = () => y ? Object.keys(y).map((e) => q(e, y)) : null, X = (e, t) => {
      if (!y || typeof y != "object") return null;
      let r = new Array();
      for (let o in y) {
        let n = q(o, y, e, t), a = e === "base" && typeof n == "string" ? n : n && n[e];
        a && (r[r.length] = a);
      }
      return r;
    }, z = {};
    for (let e in f) f[e] !== void 0 && (z[e] = f[e]);
    let D = (e, t) => {
      var r;
      let o = typeof f?.[e] == "object" ? { [e]: (r = f[e]) == null ? void 0 : r.initial } : {};
      return { ...O, ...z, ...o, ...t };
    }, H = (e = [], t) => {
      let r = [];
      for (let { class: o, className: n, ...a } of e) {
        let i = !0;
        for (let [u, c] of Object.entries(a)) {
          let A = D(u, t)[u];
          if (Array.isArray(c)) {
            if (!c.includes(A)) {
              i = !1;
              break;
            }
          } else {
            let v = (x) => x == null || x === !1;
            if (v(c) && v(A)) continue;
            if (A !== c) {
              i = !1;
              break;
            }
          }
        }
        i && (o && r.push(o), n && r.push(n));
      }
      return r;
    }, Y = (e) => {
      let t = H(j, e);
      if (!Array.isArray(t)) return t;
      let r = {};
      for (let o of t) if (typeof o == "string" && (r.base = w(r.base, o)(d)), typeof o == "object") for (let [n, a] of Object.entries(o)) r[n] = w(r[n], a)(d);
      return r;
    }, Z = (e) => {
      if (h.length < 1) return null;
      let t = {};
      for (let { slots: r = [], class: o, className: n, ...a } of h) {
        if (!p(a)) {
          let i = !0;
          for (let u of Object.keys(a)) {
            let c = D(u, e)[u];
            if (c === void 0 || (Array.isArray(a[u]) ? !a[u].includes(c) : a[u] !== c)) {
              i = !1;
              break;
            }
          }
          if (!i) continue;
        }
        for (let i of r) t[i] = t[i] || [], t[i].push([o, n]);
      }
      return t;
    };
    if (!p(C) || !k) {
      let e = {};
      if (typeof V == "object" && !p(V)) for (let t of Object.keys(V)) e[t] = (r) => {
        var o, n;
        return w(V[t], X(t, r), ((o = Y(r)) != null ? o : [])[t], ((n = Z(r)) != null ? n : [])[t], r?.class, r?.className)(d);
      };
      return e;
    }
    return w(G, F(), H(j), f?.class, f?.className)(d);
  }, W = () => {
    if (!(!y || typeof y != "object")) return Object.keys(y);
  };
  return b.variantKeys = W(), b.extend = l, b.base = G, b.slots = V, b.variants = y, b.defaultVariants = O, b.compoundSlots = h, b.compoundVariants = j, b;
};
export {
  w as cn,
  M as cnBase,
  ae as defaultConfig,
  ue as tv,
  U as voidEmpty
};
